import { intersect, partial, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import * as chat from '../../../chat';

export const Request = intersect(
	struct({
		content: iotsUtils.NotEmptyString,
	})
)(
	partial({
		id: iotsUtils.NotEmptyString,
		metadata: chat.message.Metadata,
		attributes: chat.message.Attributes,
	})
);
